<div class="row">
  <div class="col" style="font-size: 20px; color: blue;" *ngIf="business_details!=null">
    {{business_details['business_code']}}'s Order for
    {{selected_date | date: 'MMMM dd'}}<br>
    Agent : {{business_details['agent_first_name']}} {{business_details['agent_last_name']}}
  </div>
  <div class="col-3">
    <button mat-button (click)="deleteOrderIsCliked()" class="button-class" style="text-align: right;"
      *ngIf="checkDisableForDeleteButton()">Delete the
      Order</button><br>
  </div>
  <div class="col-3" (click)="closeDialog(false)" style="text-align: right;">
    <i class="material-icons" style="cursor: pointer; font-size: 28px;">
      cancel
    </i>
  </div>
</div><br>

<!-- Product Group Overall Limits Display (above table) -->
<div class="row" *ngIf="min_max_limit_dict && min_max_limit_dict.min_max_product_group_wholeday_limit">
  <div class="col" style="text-align: left; font-size: 18px;">
    <ng-container *ngIf="hasWholeDayLimits(1)">
      <span>Milk Limit:</span>
      <span [style.color]="getGroupLimitColor(1)">{{(productGroupTotals[1] || 0) | number:'1.1-1'}}L</span>
      <span *ngIf="getWholeDayLimit(1)?.min_litre !== null"> | {{getWholeDayLimit(1)?.min_litre}}L (min)</span>
      <span *ngIf="getWholeDayLimit(1)?.max_litre !== null"> | {{getWholeDayLimit(1)?.max_litre}}L (max)</span>
    </ng-container>
  </div>
</div>

<!-- Table Headers with Session Min/Max Row -->
<div *ngIf="product_form_dict!==null">
  <div class="row" style="text-align: center; font-size: 22px; font-weight: bold;">
    <div class="col-4"></div>
    <div class="col-2" *ngFor="let session of session_list">
      {{session['display_name']}}
    </div>
    <div class="col-4" style="text-align: right;">
      <label>Price</label>
    </div>
  </div>
  <!-- Session min/max row (for Milk group) -->
  <div class="row" style="text-align: center; font-size: 14px; color: #b22222;">
    <div class="col-4"></div>
    <div class="col-2" *ngFor="let session of session_list">
      <span *ngIf="getSessionMin && getSessionMin(1, session.id) !== null"
        [style.color]="getSessionLimitColor(1, session.id)">
        {{getSessionCurrent(1, session.id) | number:'1.1-1'}}L (cur)
        <br>{{getSessionMin(1, session.id)}}L (min)
      </span>
      <span *ngIf="getSessionMax && getSessionMax(1, session.id) !== null"
        [style.color]="getSessionLimitColor(1, session.id)">
        <br>{{getSessionMax(1, session.id)}}L (max)
      </span>
    </div>
    <div class="col-4"></div>
  </div>
  <!-- Product Rows (unchanged) -->
  <div class="row" *ngFor="let product of product_list; let product_index=index">
    <div class="col-12" *ngIf="product_groupby_list[product.product_group_id][0] === product.product_id">
      <hr style="background-color: #fff4f4; width: 80%;" *ngIf="product.product_group_id !== 1" style="width: 88%;">
      <label *ngIf="product.product_group_id == 3">Loose Can milk <span
          [style.color]="enable_minimum_warning_for_loose_milk ? 'red': 'black'">Minimum quanity is
          {{product['minimum_quantity']}}</span></label>
    </div>
    <div class="col"> {{product.product_short_name}}<br>
      <div *ngIf="product.product_group_id != 3"
        style="font-size: 12px;font-style: italic; margin-left: 15%; color: #aca4a4;">
        {{product.product_mrp | currency:'INR'}}</div>
      <div style="font-size: 12px; font-style: italic; color: gray;" *ngIf="product.product_group_id == 3">
        <div *ngFor="let variation_product of product_quantity_variation_list[product.product_id]">
          {{variation_product['min_quantity']}} <span *ngIf="variation_product['max_quantity'] <= 1000"> to
            1000</span>
          <span *ngIf="variation_product['max_quantity'] > 1000"> and above</span> -
          {{variation_product['mrp'] | currency: 'INR'}}
        </div>
      </div>
      <!-- Individual product limits display -->
      <div style="font-size: 12px; font-style: italic; color: #e83e8c;"
        *ngIf="min_max_limit_dict?.min_max_product_limit && min_max_limit_dict.min_max_product_limit[product.product_id] && (min_max_limit_dict.min_max_product_limit[product.product_id].min_packet !== null || min_max_limit_dict.min_max_product_limit[product.product_id].max_packet !== null)">
        <ng-container *ngIf="min_max_limit_dict.min_max_product_limit[product.product_id].min_packet !== null">
          Min:
          {{min_max_limit_dict.min_max_product_limit[product.product_id].min_packet}}
          packets
          <span *ngIf="min_max_limit_dict.min_max_product_limit[product.product_id].is_per_session">/session</span>
        </ng-container>
        <ng-container *ngIf="min_max_limit_dict.min_max_product_limit[product.product_id].max_packet !== null">
          <br>Max:
          {{min_max_limit_dict.min_max_product_limit[product.product_id].max_packet}}
          packets
          <span *ngIf="min_max_limit_dict.min_max_product_limit[product.product_id].is_per_session">/session</span>
        </ng-container>
      </div>
    </div>

    <div class="col" *ngFor="let session of session_list">
      <input type="tel" class="border-class" placeholder="0" [min]="0"
        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        [(ngModel)]="product_form_dict['session'][session.id]['product'][product.product_id]['quantity']"
        (ngModelChange)="productQuantityChanged(session.id, product.product_id, product.product_mrp, product_index,  product.product_quantity)"
        [disabled]="checkExpiry(session, product)" [style.border-color]="product.color"
        style="border: 1px solid; padding: 2px;"
        [style.background]="checkExpiry(session, product) ? 'lightgray': 'none'" />
    </div>
    <div class="col-4" style="text-align: right;">
      <label style="margin-left: 5%;">
        {{product_form_dict['total_price_per_product'][product.product_id] | currency:'INR'}}</label>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <hr style="background-color: #b7b6b6">
    </div>
  </div>
  <div style="text-align: right; color: #7b8182; font-size: 19px;" class="row">
    <div class="col-8">Total price :</div>
    <div class="col-4">{{product_form_dict['total_price_per_date'] | currency:'INR'}}</div>
  </div>
  <div style="text-align: right; color: #7b8182; font-size: 19px;" class="row">
    <div class="col-8">Already paid :</div>
    <div class="col-4">{{amount_before_edit | currency:'INR'}}</div>
  </div>
  <div class="row">
    <div class="col-12">
      <hr style="background-color: #b7b6b6">
    </div>
  </div>
  <div class="row">
    <div class="col-2" *ngIf="disable_button">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>
    <div class="col" style="text-align: center;">
      <button (click)="updateClicked()" mat-raised-button [disabled]="checkConfirmButtonValid()" class="button-class"
        style="font-size: 23px;">
        Update
      </button><br>
    </div>
  </div>
</div>